/**
 * Javascript specific to the Bootstrap Modals
 */

(function (window, document, $) {
    'use strict';

    $(document).on('click', '.modal-header__close', function(){
        $(this).closest('.modal').modal("hide");
    });

    $(document).on('click', '.modal-button--cancel', function(){
        $(this).closest('.modal').modal("hide");
    });

    $(document).on('click', '.modal-button--continue', function(){
        $(this).closest('.modal').modal("hide");
    });

    // jhlongScroll - covers longer distance
    $.fn.jhLongScroll = function( delta ) { 
        var time     = 500;
        var distance = 1200;
        // jQuery animate to perform scroll
        $( this ).stop().animate({  
            scrollTop: $( this ).scrollTop() - ( distance * delta )
        }, time );  
    }
 
    // Improve Scroll - For mousewheel events
    $( '.modal-body__content' ).bind('mousewheel DOMMouseScroll', function( e ) {
        e.preventDefault();
        var delta    = 0; 
        // determine delta for scroll distance        
        if ( e.originalEvent.wheelDelta ) delta  = e.originalEvent.wheelDelta / 120;
        else if ( e.originalEvent.detail ) delta = -e.originalEvent.detail / 3;
        
        $( this ).jhLongScroll( delta ); 
    });

    window.modal = {

        selector: '#js-modal',

        addClass: function( className ) {
            $( this.selector ).find('.modal-content').addClass( className );
        },
        close: function() {
            $( this.selector ).modal('hide');
        },
        dynamic_open: function( title, content, cancelButton, continueButton, footer, modalID ) {
            var title  = ( title ) ? title : '';
            var footer = footer || false;
            var $modal = ( modalID ) ? $( '#' + modalID ) : $( this.selector );

            if ( cancelButton ) {
                content += '<div class="modal-button modal-button--cancel">' + localized.modal.cancelButtonText + '</div>'
            }

            if ( continueButton ) {
                content += '<div class="modal-button modal-button--continue">' + localized.modal.continueButtonText + '</div>'
            }

            if ( footer ) {
                $modal.find('.modal-footer__content').html(footer); 
            }

            $modal.find('.modal-header__title').text(title);
            $modal.find('.modal-body__content').html(content);
            $modal.removeAttr("tabIndex");
            $modal.modal('show');
        },
        onBeforeShow: function( callback ) {
            $( this.selector ).on('show.bs.modal', callback );
        },
        onBeforeShowRemove: function( callback ) {
            $( this.selector ).off('show.bs.modal', callback );
        },
        onAfterShow: function( callback ) {
            $( this.selector ).on( 'shown.bs.modal', callback );
        },
        onAfterShowRemove: function( callback ) {
            $( this.selector ).off( 'shown.bs.modal', callback );
        },
        onBeforeClose: function( callback ) {
            $( this.selector ).on('hide.bs.modal', callback );
        },
        onBeforeCloseRemove: function( callback ) {
            $( this.selector ).off('hide.bs.modal', callback );
        },
        onAfterClose: function( callback ) {
            $( this.selector ).on( 'hidden.bs.modal', callback );
        },
        onAfterCloseRemove: function( callback ) {
            $( this.selector ).off( 'hidden.bs.modal', callback );
        },
        show: function() {
            $( this.selector ).modal('show');
        }
    }

})( window, document, jQuery );
